<!-- eslint-disable @angular-eslint/template/no-call-expression -->
@if (isComponentVisible()) {
  @if (isDragAndDropEnabled) {
    <div
      class="drag"
      cdkDrag
      [cdkDragDisabled]="!isDragAndDropEnabled">
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </div>
  } @else {
    <ng-container *ngTemplateOutlet="content"></ng-container>
  }

  <ng-template #content>
    <div
      lazyLoad
      class="slice-drag-container"
      (lazyLoad)="onRenderComponent()">
      @if (canBeMove() && slice?.settings?.general.firstTimeText) {
        <div>
          <render-wysiwyg
            class="tooltip"
            [html]="slice.settings.general.firstTimeText">
          </render-wysiwyg>
        </div>
      }
      @if (canBeClosed()) {
        <slice-drag-close
          [settings]="slice.settings"
          [isMobile]="isMobile"
          (click)="deleteSlice()">
        </slice-drag-close>
      }

      @for (slot of slots; track trackByIndex($index); let i = $index) {
        @if (!slot.hidden) {
          <render-slice-slot
            data-e2e="render-slice-slot"
            class="slot"
            [ngClass]="{ 'animation-drag': canBeMove()}"
            [slice]="slice"
            [slot]="(i + 1).toString()"
            [ngStyle]="getSlotStyles(slot)">
          </render-slice-slot>
        }
      }

      @if (hasCustomCursorIcon) {
        <img
          #image
          alt="custom-cursor-icon"
          class="cursor-image"
          [src]="customCursorIcon"
          [attr.width]="slice?.settings?.general?.customCursor?.width"
          [attr.height]="slice?.settings?.general?.customCursor?.height"/>
      }
    </div>
  </ng-template>
}
